module.exports = __webpack_public_path__ + "img/main-320.279014c5.png";